import { Subscription } from "rxjs";
import { DYNAMIC_SELECT_ITEM } from "../../../app.constants";
import {
  ReportElement,
  ReportUnits,
  ReportFonts,
  ReportPaperSize,
  ReportPageMargin,
  ElementType,
  BORDER_STYLE,
  FONT_FAMILY
} from "../../../_objects/report-element";
import { ReportPreviewMetadata, PropertyPreviewMetadata, FieldType, UpdateMetadata } from "../../../_services/offline-report-preview.service";
import { ReportCommonSection } from "./report-common-section";
import {
  Validation,
  TemplateDataPlateImageInfo,
  TemplateDataPlateText,
  TemplateImage,
  TemplateDataPlate,
  TemplateText,
  Options
} from "./report-template";

export class ReportDataPlate extends ReportElement {
  public top: string;
  public left: string;
  public width: string;
  public height: string;
  public zIndex: number;

  // public title: TemplateText;
  public titleTop: string;
  public titleLeft: string;
  public titleWidth: string;
  public titleHeight: string;
  public titlePadding: string;
  public titlePaddingLeft: string;
  public titlePaddingBottom: string;
  public titlePaddingRight: string;
  public titlePaddingTop: string;
  public titleZIndex: number;
  public titleText: string;
  public titleFontSize: string;
  public titleFontFamily: string;
  public titleFontColor: string;
  public titleFontStyle: string;
  public titleFontWeight: string;
  public titleLineHeight: string;
  public titleTextAlign: string;
  public titleVerticalAlign: string;
  public titleBorderWidth: string;
  public titleBorderStyle: string;
  public titleBorderColor: string;
  public titleBackgroundColor: string;
  public titleIsHorizontal: boolean;
  public titleJustifyContent: string;
  public titleAlignItems: string;

  public titleType: string;
  public titleFormat: string;
  public titleDynamicId: string;
  public titleInputType: string;
  public titleEditableId: string;
  public titleValidation: Validation;
  public titleRadioType: string;
  public titleRadioLabel: string;
  public titleOptions: Options[];
  public titleMultiSelectDelimiter: string;
  public titleLabel: string;
  public titleValue: string;
  public titleInputGroup: string;

  public imageInfo: TemplateDataPlateImageInfo;
  public imageInfoTop: string;
  public imageInfoLeft: string;
  public imageInfoWidth: string;
  public imageInfoHeight: string;
  public imageInfoZIndex: number;
  public imageInfoTitle: TemplateDataPlateText;
  public imageInfoTitleTop: string;
  public imageInfoTitleLeft: string;
  public imageInfoTitleWidth: string;
  public imageInfoTitleHeight: string;
  public imageInfoTitleZIndex: number;
  public imageInfoTitleText: string;
  public imageInfoImage: TemplateImage;
  public imageInfoImageTop: string;
  public imageInfoImageLeft: string;
  public imageInfoImageWidth: string;
  public imageInfoImageHeight: string;
  public imageInfoImageZIndex: number;
  public imageInfoImageCaption: string;
  public imageInfoImageSrc: string;
  public imageInfoImageType: string;
  public imageInfoImageOrientation: number;

  private units: ReportUnits;
  private fonts: ReportFonts;
  private paperSize: ReportPaperSize;
  private pageMargin: ReportPageMargin;
  private header: ReportCommonSection;
  private footer: ReportCommonSection;

  private baseDef: TemplateDataPlate;
  private readonly metaId = "id";
  private readonly metaTop = "y";
  private readonly metaLeft = "x";
  private readonly metaWidth = "width";
  private readonly metaHeight = "height";
  private readonly metaZIndex = "zIndex";
  private readonly metaTitle = "title";
  private readonly metaBorderWidth = "borderWidth";
  private readonly metaBorderStyle = "borderStyle";
  private readonly metaBorderColor = "borderColor";
  private readonly metaBGColor = "backgroundColor";
  private readonly metaFontSize = "fontSize";
  private readonly metaFontFamily = "fontFamily";
  private readonly metaFontStyle = "fontStyle";
  private readonly metaFontWeight = "fontWeight";
  private readonly metaFontColor = "fontColor";
  private readonly metaTextAlign = "horizontalAlign";
  private readonly metaVerticalAlign = "verticalAlign";
  private readonly metaLineHeight = "lineHeight";
  private readonly metaPadding = "padding";
  private readonly metaPaddingLeft = "paddingLeft";
  private readonly metaPaddingBottom = "paddingBottom";
  private readonly metaPaddingRight = "paddingRight";
  private readonly metaPaddingTop = "paddingTop";
  private readonly metaText = "text";

  private readonly metaIsHorizontal = "isHorizontal";
  private readonly metaType = "type";
  private readonly metaDynamicId = "dynamicId";
  private readonly metaEditableId = "editableId";
  private readonly metaInputType = "inputType";
  private readonly metaValidation = "validation";
  private readonly metaFormat = "format";
  private readonly metaRequired = "required";
  private readonly metaMaxLength = "maxLength";
  private readonly metaRadioType = "radioType";
  private readonly metaRadioLabel = "radioLabel";
  private readonly metaOptions = "options";
  private readonly metaMultiSelectDelimiter = "multiSelectDelimiter";
  private readonly metaLabel = "label";
  private readonly metaValue = "value";
  private readonly metaInputGroup = "inputGroup";

  private readonly metaImageInfo = "imageInfo";
  private readonly metaImage = "image";
  private readonly metaCaption = "caption";
  private readonly metaSrc = "src";
  private readonly metaOrientaion = "orientation";

  constructor(
    type: ElementType,
    index: number,
    units: ReportUnits,
    fonts: ReportFonts,
    header: ReportCommonSection,
    footer: ReportCommonSection,
    paperSize: ReportPaperSize,
    pageMargin: ReportPageMargin,
    templateDataPlate?: TemplateDataPlate
  ) {
    super(type, index, !(templateDataPlate == null), templateDataPlate ? templateDataPlate.id : null);

    this.units = units;
    this.fonts = fonts;
    this.header = header;
    this.footer = footer;
    this.paperSize = paperSize;
    this.pageMargin = pageMargin;

    if (templateDataPlate) {
      this.baseDef = templateDataPlate;
    } else {
      const title = {
        id: this.generateUUID(),
        x: 0, // 初期値を0で仮設定
        y: 0, // 初期値を0で仮設定
        width: Math.floor(this.pageMargin.getPaddedWidthNum(this.paperSize.getWidthNum())), // 初期値を0で仮設定
        height: Math.floor(this.pageMargin.getPaddedHeightNum(this.paperSize.getHeightNum())), // 初期値を0で仮設定
        zIndex: 0, // 初期値を0で仮設定
        borderColor: null,
        borderStyle: null,
        borderWidth: null,
        backgroundColor: null,
        type: "static", // 初期値をstaticで仮設定
        text: null,
        format: null,
        fontSize: null,
        fontFamily: null,
        fontColor: null,
        fontStyle: null,
        fontWeight: null,
        horizontalAlign: "left", // 初期値をleftで仮設定
        verticalAlign: "center", // 初期値をcenterで仮設定
        isHorizontal: true, // 初期値をtrueで設定
        lineHeight: null,
        dynamicId: null,
        dynamicDataField: null, // 初期値をnullで仮設定
        inputType: "text", // 初期値をtextで仮設定
        editableId: null,
        validation: null,
        radioType: null,
        radioLabel: null,
        options: null,
        label: null,
        value: null,
        inputGroup: null,
        padding: null,
        paddingRight: 0.5,
        paddingBottom: 0.5,
        paddingLeft: 0.5,
        paddingTop: 0.5,
        multiSelectDelimiter: "comma",
        isTableText: false
      };
      const imageInfoTitle = {
        id: this.generateUUID(),
        x: 0, // 初期値を0で仮設定
        y: 0, // 初期値を0で仮設定
        width: Math.floor(this.pageMargin.getPaddedWidthNum(this.paperSize.getWidthNum())), // 初期値を0で仮設定
        height: 0, // 初期値を0で仮設定
        zIndex: 0, // 初期値を0で仮設定
        borderColor: null,
        borderStyle: null,
        borderWidth: null,
        backgroundColor: null,
        type: "static", // 初期値をstaticで仮設定
        text: null,
        format: null,
        fontSize: null,
        fontFamily: null,
        fontColor: null,
        fontStyle: null,
        fontWeight: null,
        horizontalAlign: "left", // 初期値をleftで仮設定
        verticalAlign: "center", // 初期値をcenterで仮設定
        isHorizontal: true, // 初期値をtrueで設定
        lineHeight: null,
        dynamicId: null,
        dynamicDataField: null, // 初期値をnullで仮設定
        inputType: "text", // 初期値をtextで仮設定
        editableId: null,
        validation: null,
        radioType: null,
        radioLabel: null,
        options: null,
        label: null,
        value: null,
        inputGroup: null,
        padding: null,
        paddingRight: 0.5,
        paddingBottom: 0.5,
        paddingLeft: 0.5,
        paddingTop: 0.5,
        position: "top", // 初期値をtopで仮設定
        multiSelectDelimiter: "comma",
        isTableText: false
      };
      const imageInfoImage = {
        id: this.generateUUID(),
        x: 0, // 初期値を0で仮設定
        y: 0, // 初期値を0で仮設定
        width: Math.floor(this.pageMargin.getPaddedWidthNum(this.paperSize.getWidthNum()) / 2), // 初期値を0で仮設定
        height: 0, // 初期値を0で仮設定
        zIndex: 0, // 初期値を0で仮設定
        src: null,
        type: "static", // 初期値をstaticで仮設定
        dynamicDataField: null, // 初期値をnullで仮設定
        dynamicId: null
      };
      this.baseDef = {
        id: this.generateUUID(),
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        zIndex: 0,
        title: title,
        imageInfo: {
          id: this.generateUUID(),
          x: 0,
          y: 0,
          width: 0,
          height: 0,
          title: imageInfoTitle,
          image: imageInfoImage
        }
      };
    }
    // title
    this.titleTop = this.units.concatenate("sizeUnit", this.baseDef.title.y);
    this.titleLeft = this.units.concatenate("sizeUnit", this.baseDef.title.x);
    this.titleWidth = this.units.concatenate("sizeUnit", this.baseDef.title.width);
    this.titleHeight = this.units.concatenate("sizeUnit", this.baseDef.title.height);
    this.titleZIndex = this.baseDef.title.zIndex;
    this.titleFontColor = this.baseDef.title.fontColor;
    this.titleFontFamily = this.baseDef.title.fontFamily;
    this.titleFontSize = this.units.concatenate("fontSizeUnit", this.baseDef.title.fontSize);
    this.titleFontStyle = this.baseDef.title.fontStyle;
    this.titleFontWeight = this.baseDef.title.fontWeight;
    this.titleVerticalAlign = this.baseDef.title.verticalAlign;
    this.titleTextAlign = this.baseDef.title.horizontalAlign;
    this.titleLineHeight = this.units.concatenate("sizeUnit", this.baseDef.title.lineHeight);
    this.titleBackgroundColor = this.baseDef.title.backgroundColor;
    this.titleBorderColor = this.baseDef.title.borderColor;
    this.titleBorderStyle = this.baseDef.title.borderStyle;
    this.titleBorderWidth = this.units.concatenate("sizeUnit", this.baseDef.title.borderWidth);
    this.titleText = this.getText(this.baseDef.title);
    this.titleJustifyContent = this.getJustifyContent();
    this.titleAlignItems = this.getAlignItems();
    this.titleType = this.baseDef.title.type;
    this.titleFormat = this.baseDef.title.format;
    this.titleDynamicId = this.baseDef.title.dynamicId;
    this.titleInputType = this.baseDef.title.inputType;
    this.titleEditableId = this.baseDef.title.editableId;
    this.titleValidation = this.baseDef.title.validation;
    this.titleRadioType = this.baseDef.title.radioType;
    this.titleRadioLabel = this.baseDef.title.radioLabel;
    this.titleOptions = this.baseDef.title.options;
    this.titleMultiSelectDelimiter = this.baseDef.title.multiSelectDelimiter;
    this.titleLabel = this.baseDef.title.label;
    this.titleValue = this.baseDef.title.value;
    this.titleInputGroup = this.baseDef.title.inputGroup;
    // imageInfo
    this.imageInfo = this.baseDef.imageInfo;
    this.imageInfoTop = this.units.concatenate("sizeUnit", this.baseDef.imageInfo.y);
    this.imageInfoLeft = this.units.concatenate("sizeUnit", this.baseDef.imageInfo.x);
    this.imageInfoWidth = this.units.concatenate("sizeUnit", this.baseDef.imageInfo.width);
    this.imageInfoHeight = this.units.concatenate("sizeUnit", this.baseDef.imageInfo.height);
    // imageInfo - title
    this.imageInfoTitle = this.baseDef.imageInfo.title;
    if (this.imageInfoTitle !== null) {
      this.imageInfoTitleTop = this.units.concatenate("sizeUnit", this.baseDef.imageInfo.title.y);
      this.imageInfoTitleLeft = this.units.concatenate("sizeUnit", this.baseDef.imageInfo.title.x);
      this.imageInfoTitleWidth = this.units.concatenate("sizeUnit", this.baseDef.imageInfo.title.width);
      this.imageInfoTitleHeight = this.units.concatenate("sizeUnit", this.baseDef.imageInfo.title.height);
      this.imageInfoTitleZIndex = this.baseDef.imageInfo.title.zIndex;
      this.imageInfoTitleText = this.getText(this.baseDef.imageInfo.title);
    }
    // imageInfo - image
    this.imageInfoImage = this.baseDef.imageInfo.image;
    if (this.imageInfoImage !== null) {
      this.imageInfoImageTop = this.units.concatenate("sizeUnit", this.baseDef.imageInfo.image.y);
      this.imageInfoImageLeft = this.units.concatenate("sizeUnit", this.baseDef.imageInfo.image.x);
      this.imageInfoImageWidth = this.units.concatenate("sizeUnit", this.baseDef.imageInfo.image.width);
      this.imageInfoImageHeight = this.units.concatenate("sizeUnit", this.baseDef.imageInfo.image.height);
      this.imageInfoImageZIndex = this.baseDef.imageInfo.image.zIndex;
    }

    this.setChainUpdate();
    this.setPreviewMetadata();
  }

  public setDrawData(metadata: ReportPreviewMetadata) {
    this.updateProperties({
      id: this.getId(),
      name: this.metaTop,
      parentName: this.metaTitle,
      value: this.units.fromPx("sizeUnit", metadata.topPx),
      oldValue: this.baseDef[this.metaTitle][this.metaTop]
    });

    this.updateProperties({
      id: this.getId(),
      name: this.metaLeft,
      parentName: this.metaTitle,
      value: this.units.fromPx("sizeUnit", metadata.leftPx),
      oldValue: this.baseDef[this.metaTitle][this.metaLeft]
    });

    this.updateProperties({
      id: this.getId(),
      name: this.metaWidth,
      parentName: this.metaTitle,
      value: this.units.fromPx("sizeUnit", metadata.widthPx),
      oldValue: this.baseDef[this.metaTitle][this.metaWidth]
    });

    this.updateProperties({
      id: this.getId(),
      name: this.metaHeight,
      parentName: this.metaTitle,
      value: this.units.fromPx("sizeUnit", metadata.heightPx),
      oldValue: this.baseDef[this.metaTitle][this.metaHeight]
    });
  }
  public setDropData(metadata: ReportPreviewMetadata) {
    this.updateProperties({
      id: this.getId(),
      name: this.metaTop,
      parentName: this.metaTitle,
      value: this.units.fromPx("sizeUnit", metadata.topPx),
      oldValue: this.baseDef[this.metaImageInfo][this.metaTop]
    });
    this.updateProperties({
      id: this.getId(),
      name: this.metaLeft,
      parentName: this.metaTitle,
      value: this.units.fromPx("sizeUnit", metadata.leftPx),
      oldValue: this.baseDef[this.metaImageInfo][this.metaLeft]
    });
  }

  public setResizeData(metadata: ReportPreviewMetadata) {
    this.updateProperties({
      id: this.getId(),
      name: this.metaTop,
      parentName: this.metaTitle,
      value: this.units.fromPx("sizeUnit", metadata.topPx),
      oldValue: this.baseDef[this.metaTitle][this.metaTop]
    });
    this.updateProperties({
      id: this.getId(),
      name: this.metaLeft,
      parentName: this.metaTitle,
      value: this.units.fromPx("sizeUnit", metadata.leftPx),
      oldValue: this.baseDef[this.metaTitle][this.metaLeft]
    });
    this.updateProperties({
      id: this.getId(),
      name: this.metaWidth,
      parentName: this.metaTitle,
      value: this.units.fromPx("sizeUnit", metadata.widthPx),
      oldValue: this.baseDef[this.metaTitle][this.metaWidth]
    });
    this.updateProperties({
      id: this.getId(),
      name: this.metaHeight,
      parentName: this.metaTitle,
      value: this.units.fromPx("sizeUnit", metadata.heightPx),
      oldValue: this.baseDef[this.metaTitle][this.metaHeight]
    });
  }

  public getLeftPx(): number {
    return this.units.toPx("sizeUnit", this.baseDef[this.metaImageInfo][this.metaLeft]);
  }
  public getTopPx(): number {
    return this.units.toPx("sizeUnit", this.baseDef[this.metaImageInfo][this.metaTop]);
  }
  public getWidthPx(): number {
    return this.units.toPx("sizeUnit", this.baseDef[this.metaImageInfo][this.metaWidth]);
  }
  public getHeightPx(): number {
    return this.units.toPx("sizeUnit", this.baseDef[this.metaImageInfo][this.metaHeight]);
  }

  public getTemplateJSON(): TemplateDataPlate {
    return this.baseDef;
  }

  protected getPreviewMetadata(): PropertyPreviewMetadata[] {
    return [
      {
        name: this.metaLeft,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Number",
        selectItems: [],
        isRequired: true,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaTop,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Number",
        selectItems: [],
        isRequired: true,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaWidth,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Number",
        selectItems: [],
        isRequired: true,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaHeight,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Number",
        selectItems: [],
        isRequired: true,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaType,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Select",
        selectItems: [
          { label: "static", value: "static" },
          { label: "dynamic", value: "dynamic" },
          { label: "dynamic-editable", value: "dynamic-editable" }
        ],
        isRequired: true,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaInputType,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Select",
        selectItems: [
          { label: "text", value: "text" },
          { label: "textArea", value: "textArea" },
          { label: "radio", value: "radio" },
          { label: "select", value: "select" },
          { label: "date", value: "date" },
          { label: "date", value: "date" }
        ],
        isRequired: true,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaText,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "TextArea",
        selectItems: [],
        isRequired: true,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaDynamicId,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Select",
        selectItems: DYNAMIC_SELECT_ITEM,
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaEditableId,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Text",
        selectItems: [],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaFormat,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Select",
        selectItems: [
          { label: "01/01/2019", value: "MM/dd/yyyy" },
          { label: "1/1/2019", value: "M/d/yyyy" },
          { label: "1/1/19", value: "M/d/yy" },
          { label: "2019/1/1", value: "yyyy/M/d" },
          { label: "19/1/1", value: "yy/M/d" },
          { label: "2019-01-01", value: "yyyy-MM-dd" },
          { label: "2019-1-1", value: "yyyy-M-d" },
          { label: "19-01-01", value: "yy-MM-dd" },
          { label: "January 1, 2019", value: "MMMM d, yyyy" },
          { label: "January 01, 2019", value: "MMMM dd, yyyy" },
          { label: "Tuesday, January 01, 2019", value: "dddd, MMMM dd, yyyy" },
          { label: "Tuesday, Jan 1, 2019", value: "dddd, MMM d, yyy" },
          { label: "Tues, Jan 1, 2019", value: "ddd, MMM d, yyyy" },
          { label: "1/10", value: "$/#" },
          { label: "1", value: "$" },
          { label: "p.1", value: "p.$" },
          { label: "Page 1 of 10", value: "Page $ of #" }
        ],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaMaxLength,
        parentName: this.metaValidation,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Integer",
        selectItems: [],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaOptions,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Multi",
        selectItems: [],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaMultiSelectDelimiter,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Select",
        selectItems: [
          { label: "comma", value: "comma" },
          { label: "new line", value: "newline" }
        ],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaRadioType,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Select",
        selectItems: [
          { label: "check", value: "check" },
          { label: "circle", value: "circle" },
          { label: "disc", value: "disc" }
        ],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaRadioLabel,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Text",
        selectItems: [],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaValue,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Text",
        selectItems: [],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaZIndex,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Integer",
        selectItems: [],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaBorderColor,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Color",
        selectItems: [],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaBorderStyle,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Select",
        selectItems: BORDER_STYLE,
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaBorderWidth,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Number",
        selectItems: [],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaBGColor,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Color",
        selectItems: [],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaFontSize,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Number",
        selectItems: [],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaFontFamily,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Select",
        selectItems: FONT_FAMILY,
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaFontColor,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Color",
        selectItems: [],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaFontStyle,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Select",
        selectItems: [
          { label: "italic", value: "italic" },
          { label: "oblique", value: "oblique" }
        ],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaFontWeight,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Select",
        selectItems: [
          { label: "normal", value: "normal" },
          { label: "bold", value: "bold" },
          { label: "lighter", value: "lighter" },
          { label: "bolder", value: "bolder" },
          { label: "100", value: "100" },
          { label: "200", value: "200" },
          { label: "300", value: "300" },
          { label: "400", value: "400" },
          { label: "500", value: "500" },
          { label: "600", value: "600" },
          { label: "700", value: "700" },
          { label: "800", value: "800" },
          { label: "900", value: "900" }
        ],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaTextAlign,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Select",
        selectItems: [
          { label: "left", value: "left" },
          { label: "center", value: "center" },
          { label: "right", value: "right" }
        ],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaVerticalAlign,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Select",
        selectItems: [
          { label: "top", value: "top" },
          { label: "middle", value: "middle" },
          { label: "bottom", value: "bottom" }
        ],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaLineHeight,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Number",
        // ↑ CSSプロパティ「lineHight」は文字列値も受け付けられたような。。。
        selectItems: [],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaRequired,
        parentName: this.metaValidation,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "CheckBox",
        selectItems: [],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaLabel,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Text",
        selectItems: [],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaInputGroup,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Text",
        selectItems: [],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      {
        name: this.metaPadding,
        parentName: this.metaTitle,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "Text",
        selectItems: [],
        isRequired: false,
        isEdited: false,
        category: "TITLE"
      },
      // ImageInfo
      // {
      //  name: this.metaImageInfo, parentName: null, value: '',
      //  isFieldType: (type: FieldType): boolean => type === 'JSON',
      //  selectItems: [],
      //  isRequired: true,
      //  isEdited: false,
      //  category: 'IMAGEINFO'
      // },
      {
        name: this.metaLeft,
        parentName: this.metaImageInfo,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "JSON",
        selectItems: [],
        isRequired: true,
        isEdited: false,
        category: "IMAGEINFO"
      },
      {
        name: this.metaTop,
        parentName: this.metaImageInfo,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "JSON",
        selectItems: [],
        isRequired: true,
        isEdited: false,
        category: "IMAGEINFO"
      },
      {
        name: this.metaWidth,
        parentName: this.metaImageInfo,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "JSON",
        selectItems: [],
        isRequired: true,
        isEdited: false,
        category: "IMAGEINFO"
      },
      {
        name: this.metaHeight,
        parentName: this.metaImageInfo,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "JSON",
        selectItems: [],
        isRequired: true,
        isEdited: false,
        category: "IMAGEINFO"
      },
      {
        name: this.metaZIndex,
        parentName: this.metaImageInfo,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "JSON",
        selectItems: [],
        isRequired: false,
        isEdited: false,
        category: "IMAGEINFO"
      },
      {
        name: this.metaTitle,
        parentName: this.metaImageInfo,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "JSON",
        selectItems: [],
        isRequired: true,
        isEdited: false,
        category: "IMAGEINFO"
      },
      {
        name: this.metaImage,
        parentName: this.metaImageInfo,
        value: "",
        isFieldType: (type: FieldType): boolean => type === "JSON",
        selectItems: [],
        isRequired: true,
        isEdited: false,
        category: "IMAGEINFO"
      }
    ];
  }

  protected setUpdateMetadata(metadata: UpdateMetadata) {
    switch (metadata.name) {
      case this.metaTop:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        if (metadata.parentName === this.metaTitle) {
          this.titleTop = this.units.concatenate("sizeUnit", metadata.value as number);
        } else if (metadata.parentName === this.metaImageInfo) {
          this.imageInfoTop = this.units.concatenate("sizeUnit", metadata.value as number);
        }
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaLeft:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        if (metadata.parentName === this.metaTitle) {
          this.titleLeft = this.units.concatenate("sizeUnit", metadata.value as number);
        } else if (metadata.parentName === this.metaImageInfo) {
          this.imageInfoLeft = this.units.concatenate("sizeUnit", metadata.value as number);
        }
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaWidth:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        if (metadata.parentName === this.metaTitle) {
          this.titleWidth = this.getWidth();
        } else if (metadata.parentName === this.metaImageInfo) {
          this.imageInfoWidth = this.units.concatenate("sizeUnit", metadata.value as number);
        }
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaHeight:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        if (metadata.parentName === this.metaTitle) {
          this.titleHeight = this.units.concatenate("sizeUnit", this.baseDef.title.height);
        } else if (metadata.parentName === this.metaImageInfo) {
          this.imageInfoHeight = this.units.concatenate("sizeUnit", metadata.value as number);
        }
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaZIndex:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        if (metadata.parentName === this.metaTitle) {
          this.titleZIndex = metadata.value as number;
        } else if (metadata.parentName === this.metaImageInfo) {
          this.imageInfoZIndex = metadata.value as number;
        }
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaBorderColor:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        if (metadata.parentName === this.metaTitle) {
          this.titleBorderColor = metadata.value as string;
        }
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaBorderStyle:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        if (metadata.parentName === this.metaTitle) {
          this.titleBorderStyle = metadata.value as string;
        }
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaBorderWidth:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        if (metadata.parentName === this.metaTitle) {
          this.titleBorderWidth = this.units.concatenate("sizeUnit", metadata.value as number);
        }
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaTextAlign:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        if (metadata.parentName === this.metaTitle) {
          this.titleTextAlign = metadata.value as string;
        }
        this.setPreviewValue(metadata.name, metadata.value);
        break;

      case this.metaBGColor:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleBackgroundColor = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaType:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleText = this.getText(this.baseDef.title);
        this.setPreviewValue(metadata.name, metadata.value);
        if (metadata.value === "static") {
          this.setPreviewValue(this.metaDynamicId, null);
          this.baseDef[this.metaDynamicId] = null;
          this.setPreviewValue(this.metaEditableId, null);
          this.baseDef[this.metaEditableId] = null;
          this.setPreviewValue(this.metaFormat, null);
          this.baseDef[this.metaFormat] = null;
        } else if (metadata.value === "dynamic") {
          this.setPreviewValue(this.metaText, "");
          this.baseDef[this.metaText] = "";
          this.setPreviewValue(this.metaEditableId, null);
          this.baseDef[this.metaEditableId] = null;
        }
        break;
      case this.metaText:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleText = this.getText(this.baseDef.title);
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaFormat:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaFontSize:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        if (metadata.parentName === this.metaTitle) {
          this.titleFontSize = this.fonts.getFontSize(this.baseDef.title);
          this.setPreviewValue(metadata.name, metadata.value);
        }
        break;
      case this.metaFontFamily:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        if (metadata.parentName === this.metaTitle) {
          this.titleFontFamily = this.fonts.getFontFamily(this.baseDef.title);
          this.setPreviewValue(metadata.name, metadata.value);
        }
        break;
      case this.metaFontColor:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleFontColor = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaFontStyle:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleFontStyle = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaFontWeight:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleFontWeight = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaVerticalAlign:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleVerticalAlign = metadata.value as string;
        this.titleAlignItems = this.getAlignItems();
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaIsHorizontal:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as boolean;
        this.titleIsHorizontal = metadata.value as boolean;
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaLineHeight:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as number;
        this.titleLineHeight = this.units.concatenate("sizeUnit", metadata.value as number);
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaDynamicId:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleText = this.getText(this.baseDef.title);
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaInputType:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value);
        if (metadata.value !== "select") {
          this.setPreviewValue(this.metaOptions, "[]");
          this.baseDef[this.metaOptions] = [];
        }
        if (metadata.value !== "radio") {
          this.setPreviewValue(this.metaRadioType, null);
          this.baseDef[this.metaRadioType] = null;
          this.setPreviewValue(this.metaRadioLabel, null);
          this.baseDef[this.metaRadioLabel] = null;
          this.setPreviewValue(this.metaValue, null);
          this.baseDef[this.metaValue] = null;
        }
        break;
      case this.metaEditableId:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.titleText = this.getText(this.baseDef.title);
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaRequired:
        if (!this.baseDef[this.metaValidation]) {
          this.baseDef[this.metaValidation] = { required: false, maxLength: null };
        }
        this.baseDef[this.metaValidation][metadata.name] = metadata.value as boolean;
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaMaxLength:
        if (!this.baseDef[this.metaValidation]) {
          this.baseDef[this.metaValidation] = { required: false, maxLength: null };
        }
        this.baseDef[this.metaValidation][metadata.name] = metadata.value as number;
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaRadioType:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaRadioLabel:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaOptions:
        this.baseDef[metadata.parentName][metadata.name] = JSON.parse(metadata.value as string);
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaLabel:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaValue:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaInputGroup:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      case this.metaPadding:
        this.baseDef[metadata.parentName][metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value);
        break;
      // case this.metaImageInfo:
      //  this.baseDef[metadata.name] = JSON.parse(metadata.value as string);
      //  this.imageInfoTop = this.units.concatenate('sizeUnit', this.baseDef[metadata.name][this.metaTop] as number);
      //  this.imageInfoLeft = this.units.concatenate('sizeUnit', this.baseDef[metadata.name][this.metaLeft] as number);
      //  this.imageInfoWidth = this.units.concatenate('sizeUnit', this.baseDef[metadata.name][this.metaWidth] as number);
      //  this.imageInfoHeight = this.units.concatenate('sizeUnit', this.baseDef[metadata.name][this.metaHeight] as number);
      //  this.imageInfoTitle = this.baseDef[metadata.name][this.metaTitle];
      //  this.imageInfoImage = this.baseDef[metadata.name][this.metaImage]
      //  this.setPreviewValue(metadata.name, metadata.value);
      //  break;
      case this.metaTitle:
        if (metadata.parentName === this.metaImageInfo) {
          try {
            this.baseDef[metadata.parentName][metadata.name] = JSON.parse(metadata.value as string);
          } catch (_error) {
            this.baseDef[metadata.parentName][metadata.name] = metadata.value as TemplateDataPlateText;
          }
          this.imageInfoTitleTop = this.units.concatenate("sizeUnit", this.baseDef[metadata.parentName][metadata.name][this.metaTop] as number);
          this.imageInfoTitleLeft = this.units.concatenate("sizeUnit", this.baseDef[metadata.parentName][metadata.name][this.metaLeft] as number);
          this.imageInfoTitleWidth = this.units.concatenate("sizeUnit", this.baseDef[metadata.parentName][metadata.name][this.metaWidth] as number);
          this.imageInfoTitleHeight = this.units.concatenate("sizeUnit", this.baseDef[metadata.parentName][metadata.name][this.metaHeight] as number);
          this.imageInfoTitleZIndex = this.baseDef[metadata.parentName][metadata.name][this.metaZIndex] as number;
          this.imageInfoTitleText = this.baseDef[metadata.parentName][metadata.name][this.metaText];
          this.setPreviewValue(metadata.name, metadata.value);
        }
        break;
      case this.metaImage:
        if (metadata.parentName === this.metaImageInfo) {
          try {
            this.baseDef[metadata.parentName][metadata.name] = JSON.parse(metadata.value as string);
          } catch (_error) {
            this.baseDef[metadata.parentName][metadata.name] = metadata.value as TemplateImage;
          }
          this.imageInfoImageTop = this.units.concatenate("sizeUnit", this.baseDef[metadata.parentName][metadata.name][this.metaTop] as number);
          this.imageInfoImageLeft = this.units.concatenate("sizeUnit", this.baseDef[metadata.parentName][metadata.name][this.metaLeft] as number);
          this.imageInfoImageWidth = this.units.concatenate("sizeUnit", this.baseDef[metadata.parentName][metadata.name][this.metaWidth] as number);
          this.imageInfoImageHeight = this.units.concatenate("sizeUnit", this.baseDef[metadata.parentName][metadata.name][this.metaHeight] as number);
          this.imageInfoImageZIndex = this.baseDef[metadata.parentName][metadata.name][this.metaZIndex] as number;

          this.imageInfoImageCaption = this.baseDef[metadata.parentName][metadata.name][this.metaCaption];
          this.imageInfoImageSrc = this.baseDef[metadata.parentName][metadata.name][this.metaSrc];
          this.imageInfoImageType = this.baseDef[metadata.parentName][metadata.name][this.metaType];
          this.imageInfoImageOrientation = this.baseDef[metadata.parentName][metadata.name][this.metaOrientaion];

          this.setPreviewValue(metadata.name, metadata.value);
        }
        break;
    }
  }

  protected setChainUpdateFunction(_subscribers: Array<Subscription>) {}

  public getSizeUnit() {
    return this.baseDef["sizeUnit"];
  }

  private getHeightNum(): number {
    let rtn = this.paperSize.getHeightNum();
    rtn = this.pageMargin.getPaddedHeightNum(rtn);
    rtn = rtn - this.header.getHeightNum() - this.footer.getHeightNum() - this.baseDef.y * 2;
    rtn = Math.floor(rtn);
    return rtn;
  }

  private getHeight(): string {
    return [this.getHeightNum(), "mm"].join("");
  }

  private getWidthNum(): number {
    let rtn = this.paperSize.getWidthNum();
    rtn = this.pageMargin.getPaddedWidthNum(rtn) - this.baseDef.title.x * 2;
    rtn = Math.floor(rtn);
    return rtn;
  }
  private getWidth(): string {
    return [this.getWidthNum(), "mm"].join("");
  }

  private getText(text: TemplateText): string {
    let rtnText = "";
    switch (text.type) {
      case "static":
        rtnText = text.text;
        break;
      case "dynamic":
        if (text.dynamicDataField) {
          rtnText = "[" + text.dynamicDataField + "]";
        } else if (text.dynamicId) {
          rtnText = "[" + text.dynamicId + "]";
        } else {
          rtnText = "[Dynamic Text]";
        }
        break;
      case "dynamic-editable":
        rtnText = text.editableId ? "{" + text.editableId + "}" : "{Editable Text}";
        break;
    }
    return rtnText;
  }

  private getJustifyContent(): string {
    let rtn: string;
    switch (this.baseDef.title.horizontalAlign) {
      case "left":
        rtn = "flex-start";
        break;
      case "center":
        rtn = "center";
        break;
      case "right":
        rtn = "flex-end";
        break;
    }
    return rtn;
  }

  private getAlignItems(): string {
    let rtn: string;
    switch (this.baseDef.title.verticalAlign) {
      case "top":
        rtn = "flex-start";
        break;
      case "middle":
        rtn = "center";
        break;
      case "bottom":
        rtn = "flex-end";
        break;
    }
    return rtn;
  }
}
